import React from "react";
import { Image } from "react-bootstrap";

import {
  getPreviewImageModal,
  UTCToDateTimeFormatWithoutSecondsForInbox,
} from "../../../../../shared";
import useModalDisplay from "../../../../../shared/components/hooks/useModalDisplay/useModalDisplay";

const SendMessageComponent = (props) => {
  const { message, user, key } = props;

  const [showModal, modalElement, setComponent, closeModal] = useModalDisplay();

  const showPreviewImageModal = (image) => {
    setComponent(
      getPreviewImageModal({
        closeModal,
        image,
      })
    );
  };

  return (
    <>
      {showModal && modalElement}
      <div className="ms-auto message-div" key={key} data-testid="sended-image">
        <div className="green-theme me-3 mt-3 rounded-top-5 rounded-start-5 ">
          {message.message && (
            <div className="text-white chat-text py-2 px-4">
              {message.message}
            </div>
          )}
          {message.messageAttachmentLinks?.length > 0 && (
            <div className="d-flex gap-1 flex-wrap px-4 py-2">
              {message.messageAttachmentLinks.map((img) => (
                <Image
                  key={img}
                  src={img}
                  width={48}
                  height={48}
                  alt="Img"
                  title="click to preview"
                  className="rounded-2 border border-dark shadow-lg bg-white pointer"
                  onClick={() => showPreviewImageModal(img)}
                />
              ))}
            </div>
          )}
        </div>
        <div className="text-end">
          <small className="me-3 text-end sender-name">
            <strong>
              {user?.id === message?.systemUserId
                ? "You"
                : message?.systemUserName}{" "}
            </strong>
            <span className="fw-lighter text-secondary">
              {UTCToDateTimeFormatWithoutSecondsForInbox(
                Number(message.createdAt)
              )}
            </span>
          </small>
        </div>
      </div>
    </>
  );
};

export default React.memo(SendMessageComponent);
